import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { handleScrollReset } from '@/utils/navigationUtils';
const PricingCTA: React.FC = () => {
  return <section className="py-14 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold text-primary-blue mb-4">Ready to Launch Your Own Resell Referral Program?</h2>
        <p className="text-xl mb-6 max-w-3xl mx-auto text-gray-700">Start your own biz working from home we take care of all technical parts. Resell in your own name make monthly recurring income. We work on revenue share and no monthly cost to you for apps or infrastructure. Find out more get up and running in business within 48 hours.</p>
        <div className="flex flex-col sm:flex-row justify-center space-y-3 sm:space-y-0 sm:space-x-3">
          <Link to="/saas" onClick={handleScrollReset}>
            <Button className="bg-primary-blue text-white hover:bg-primary-lightBlue 
                px-8 py-3 text-lg rounded-full 
                transition-transform duration-300 
                transform hover:scale-105 
                shadow-md hover:shadow-lg 
                inline-flex items-center">
              Find Out More
            </Button>
          </Link>
        </div>
      </div>
    </section>;
};
export default PricingCTA;